import React from "react";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { appHelper } from "../../common/helper"
// Components

// Assests
import MailIcon from "../../assets/images/mail.png";
import {CustomButton,ShowMessage}  from "../../components";
import { Flex } from "antd";



const VerifyEmail = () => {   //Component updated by nisha
  const location = useLocation();
  const [state, setState] = useState(location.state || {});
  const [isFormValid, setIsFormValid] = useState(true);
  const { email, name } = state;
  const {capitalize} = appHelper();

 const  resendEmail  = () =>{
  //need implementation
 }


   return (
    <>
      <Flex vertical={true}  align="center">
        <ShowMessage
          heading="Verify your email address"
          text={`Thanks${name ? `, ${capitalize(name)}` : ''}. We’ve emailed you a link${email ? ` at ${email}` : ''} to verify your email and set up your password.`}
          icon={MailIcon}
        >
        </ShowMessage>
        <CustomButton isFormValid={isFormValid} text="Resend email" onClick={resendEmail} fontWeight="500" fontSize="16" lineHeight="20px" color="#000" height="48px" width="133px" borderRadius="8px" bgColor="#F3F3F3" />
      </Flex>
    </>
  )
};

export default VerifyEmail;
